var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:{'form-control':true, 'error':_vm.error},attrs:{"id":_vm.id,"placeholder":_vm.placeholder}})}
var staticRenderFns = []

export { render, staticRenderFns }